import script from "./OperateProcessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./OperateProcessDialog.vue?vue&type=script&setup=true&lang=js"

import "./OperateProcessDialog.vue?vue&type=style&index=0&id=34ffce36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ffce36"]])

export default __exports__